/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EvaluationSource
 */
export interface EvaluationSource {
    /**
     * 
     * @type {string}
     * @memberof EvaluationSource
     */
    attributePath: string;
    /**
     * 
     * @type {string}
     * @memberof EvaluationSource
     */
    projectIdentifier: string;
    /**
     * 
     * @type {string}
     * @memberof EvaluationSource
     */
    runIdentifier: string;
}

/**
 * Check if a given object implements the EvaluationSource interface.
 */
export function instanceOfEvaluationSource(value: object): value is EvaluationSource {
    if (!('attributePath' in value) || value['attributePath'] === undefined) return false;
    if (!('projectIdentifier' in value) || value['projectIdentifier'] === undefined) return false;
    if (!('runIdentifier' in value) || value['runIdentifier'] === undefined) return false;
    return true;
}

export function EvaluationSourceFromJSON(json: any): EvaluationSource {
    return EvaluationSourceFromJSONTyped(json, false);
}

export function EvaluationSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvaluationSource {
    if (json == null) {
        return json;
    }
    return {
        
        'attributePath': json['attributePath'],
        'projectIdentifier': json['projectIdentifier'],
        'runIdentifier': json['runIdentifier'],
    };
}

export function EvaluationSourceToJSON(value?: EvaluationSource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'attributePath': value['attributePath'],
        'projectIdentifier': value['projectIdentifier'],
        'runIdentifier': value['runIdentifier'],
    };
}

